import { Video as LucideIcon } from "lucide-react";
import { Shield, ArrowRight, Lock } from "lucide-react";
import {
  Eye,
  Server,
  CheckCircle,
  Users,
  Zap,
  Globe,
  CheckCircle2,
  Headphones,
  BarChart3,
} from "lucide-react";
import { useState } from "react";

import feature_img from "../../images/feat.png";
import data from "../../images/data_manage.webp";

const Helpdesk = () => {
  const features = [
    {
      icon: Shield,
      title: "Simple method for uploading data",
      description:
        "Excel files include a wealth of IT-related data. All of this data is loaded into the program ith the assistance of the MCT HelpDesk import tool. The user is guided, data consistency is checked, and intended modifications are reported before the user confirms them by the import wizard. Massive imports are possible for every element controlled in the application, along with their connections. This makes it easier and faster to restore and update already-existing data.",
    },
    {
      icon: Eye,
      title: "Easy access to data",
      description:
        "Reduced incident response times are mostly dependent on timely information access. To efficiently browse the CMDB, MCT HelpDesk provides a worldwide search engine in addition to multi-criteria searches. Because any Cl (or list of CIs) in MCT HelpDesk can be accessed directly with a web link, sharing a page or a search result is simple for users.",
    },
    {
      icon: Lock,
      title: "An adaptable ticketing mechanism",
      description:
        "Different ticket categories are available through MCT HelpDesk, and each has an own workflow: ● Requests from users; incidents; issues; and modifications Every time a ticket status changes, emails that may be customized can be delivered.",
    },
    {
      icon: Users,
      title: "Client web page",
      description:
        "Based on a service catalog, users can submit their requests directly. Every user has the ability to monitor the status of their requests and make online updates (such as adding more details or expressing satisfaction after closing a ticket). Email correspondence is unnecessary since MCT HelpDesk centralizes all ticket-related data.",
    },
    {
      icon: Server,
      title: "Impact analysis that is automated",
      description:
        "MCT HelpDesk simulates the laws of dependencies among several CIs. The program uses these criteria to automatically assess and graphically illustrate an element's influence on the other Cis. These riteria are used to automatically construct the list of people who will be alerted about the status of the ticket and determine the repercussions of the event when an incident or modification is created.",
    },
    {
      icon: Zap,
      title: "Dashboards",
      description:
        "MCT HelpDesk offers straightforward dashboards to track activity and the caliber of IT services rendered. Each module has customisable dashboards that are defined for the most popular uses: ● The frequency of activity for support teams; the quantity of occurrences for each service and client; and the configuration items that are now under management",
    },
  ];
  const [loading,setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    textarea: "",
    password: "",
    organization : "",
    agree: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState("");

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.fullname,
      email: formData.email,
      subject: "Request for Help Desk Product Demo",
      phone: formData.phone,
      message: formData.textarea,
    };

    try {
      const response = await fetch(`http://localhost:5000/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ " + data.message);
        setContactForm(false);
        setFormData({
          fullname: "",
          email: "",
organization : "",
          textarea: "",
          agree: false,
        });
      } else {
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };
  const handleTrial = async (e) => {
      setLoading(true)
    e.preventDefault();
    const payload = {
     name: formData.fullname,
      email: formData.email,
      subject: "Request for Help Desk Product Trial",
      phone: formData.phone,
      organization : formData.organization,
      message: formData.textarea,
   };

    try {
      const response = await fetch(`https://backend.maplecloudtechnologies.com:7443/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
          setLoading(false)
        alert("✅ " + data.message);
        setTrialForm(false);
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          password: "",
          textarea: "",
          organization : "",
          company: "",
          agree: false,
        });
      } else {
          setLoading(false)
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
        setLoading(false)
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };

  const [contactForm, setContactForm] = useState(false);
  const [trialForm, setTrialForm] = useState(false);
  const [users, setUsers] = useState("");
  return (
    <>
      {trialForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a free trial{" "}
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a free trial.
            </p>
            <form onSubmit={handleTrial} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {errors && <p className="text-red-600 text-sm">{errors}</p>}

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setTrialForm(false);
                    setFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
                >
                  Request Trial
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {contactForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a Product Demo
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a personalized demo.
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Your full name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {errors && <p className="text-red-600 text-sm">{errors}</p>}

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setContactForm(false);
                    setFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
                >
                  Request Demo
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <section className="relative overflow-hidden pt-20 pb-10 px-4 sm:px-6 lg:px-8">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 to-transparent"></div>
        <div className="absolute top-20 left-10 w-56 sm:w-72 h-56 sm:h-72 bg-blue-600/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-5 w-64 sm:w-96 h-64 sm:h-96 bg-cyan-600/20 rounded-full blur-3xl"></div>

        {/* Main Container */}
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-12 px-4 sm:px-8 mt-5">
          {/* Left Content */}
          <div className="text-start w-full lg:w-1/2 mt-5">
            <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/20 rounded-full px-4 py-2 mb-6">
              <Lock className="w-4 h-4 text-green-400" />
              <span className="text-sm text-green-300 font-medium">
                MCT Help Desk
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              <span className="block text-5xl mb-2 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                MCT HelpDesk
              </span>
              emerges as a cutting-edge web solution
            </h1>

            <p className="text-sm sm:text-lg text-slate-300 mb-10 leading-relaxed">
              MCT HelpDesk is a cutting-edge web solution for service providers
              and enterprises. Its user-friendly interface consolidates all
              configuration items and their interconnections into a unified CMDB
              platform. Say goodbye to Excel spreadsheets and embrace
              productivity as MCT HelpDesk handles requests, incidents,
              problems, changes, and service catalog management in a single
              repository.
            </p>
          </div>

          {/* Right Side Form */}
          <div className="w-full lg:w-1/2 max-w-md bg-slate-900/40 backdrop-blur-md text-white p-6 sm:p-6 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-xl sm:text-2xl font-medium mb-6 text-center lg:text-left">
              Contact for free trial
            </h1>

            <form
              onSubmit={(e) => {
                handleTrial(e);
                setUsers("");
              }}
              className="space-y-3"
            >
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Full name"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
             
               <div>
                <input
                  id="organization"
                  name="organization"
                  type="text"
                  value={formData.organization}
                  onChange={handleChange}
                  placeholder="Organization name"
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Tel."
                  
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={formData.textarea || ""}
                    onChange={handleChange}
                    
                    placeholder="Message..."
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {/* Checkbox */}
              <div className="flex items-start gap-2 text-sm">
                <input
                  id="agree"
                  name="agree"
                  type="checkbox"
                  checked={formData.agree}
                  onChange={handleChange}
                  
                  className="mt-1"
                />
                <label htmlFor="agree" className="text-gray-400">
                  I agree to the{" "}
                  <a href="#" className="text-blue-400 hover:underline">
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a href="#" className="text-blue-400 hover:underline">
                    Privacy Policy
                  </a>
                  .
                </label>
              </div>

              {/* Messages */}
              {errors && <p className="text-red-500 text-sm">{errors}</p>}
              {message && <p className="text-green-500 text-sm">{message}</p>}

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
              >
                 {
                  loading ? 'Sending...' : ' Send Request'
                }
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-blue-500/10 border border-blue-500/20 rounded-full px-4 py-2 mb-6">
              <Globe className="w-4 h-4 text-blue-400" />
              <span className="text-sm text-blue-300 font-medium">
                Why Help Desk
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Why Choose Help Desk
            </h2>
            <p className="text-xl text-slate-400 max-w-3xl mx-auto">
              Cutting-edge web solution tailored for service providers and
              enterprises alike
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div className="bg-slate-900 border border-slate-700 rounded-xl p-8 hover:border-blue-500/50 transition hover:shadow-3xl   hover:shadow-blue-500/10 group">
                <div className="bg-gradient-to-br from-blue-600 to-cyan-600 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <f.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  {f.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-xs">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        id="features"
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col items-center"
      >
        {/* Section Header */}
        <div className="w-full max-w-[300px] flex justify-center items-center gap-2 bg-blue-500/10 border border-blue-500/20 rounded-full px-4 py-2 mb-10">
          <Globe className="w-6 h-6 text-blue-400" />
          <span className="text-xl text-blue-300 font-medium">
            Features Of Help Desk
          </span>
        </div>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start w-full">
          {/* Left Side - Illustration */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={feature_img}
              alt="feature_img"
              className="w-full h-auto rounded-lg"
            />
          </div>

          {/* Right Side - Features */}
          <div className="w-full lg:w-1/2 mt-6 lg:mt-0">
            <div className="space-y-4">
              {[
                "Designed for multiple tenants with partitioned data.",
                "Offers a versatile search functionality across multiple criteria.",
                "Allows exporting data in formats like CSV, HTML, and XML.",
                "Supports importing data in CSV format.",
                "Provides a user interface that can be customized to different languages on a per-user basis.",
                "Incorporates a global search feature akin to Google's search capabilities.",
                "Enables automated email notifications.",
                "Implements access rights based on user profiles.",
                "Facilitates direct linking to any Configuration Item (CI) or list of CIs.",
                "Offers various authentication methods including built-in, LDAP, JA-SIG CAS, and external systems.",
                "Tracks changes made within the system.",
                "Features configurable dashboards for personalized monitoring and reporting.",
              ].map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-teal-600/20 rounded-full flex items-center justify-center text-teal-400">
                    <CheckCircle2 className="w-5 h-5" />
                  </div>
                  <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
                    {feature}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="customers" className="max-w-7xl mx-auto md:px-6 px-2 py-24">
        <div className="bg-gradient-to-br from-slate-800 to-cyan-900 rounded-3xl py-16 md:px-px-16 relative overflow-hidden border border-teal-700">
          <div className="absolute top-0 right-0 w-96 h-96 bg-amber-400 rounded-full opacity-5 -translate-y-1/2 translate-x-1/2"></div>

          <div className="relative z-10">
            <h2 className="text-4xl font-medium text-white text-center mb-4">
              Integration of data
            </h2>
            <p className="text-teal-100 text-center mb-12 max-w-3xl mx-auto">
              To federate information from several external sources
              (applications, files, databases), MCT HelpDesk incorporates a
              potent data synchronization engine.
            </p>

            {/* Main container */}
            <div className="relative flex flex-col lg:flex-row justify-center items-center min-h-[400px]">
              {/* Image */}
              <div className="relative z-10 w-full lg:w-[400px] h-[400px] mx-auto lg:mx-0">
                <div className="w-full h-full bg-amber-400 rounded-full flex items-end justify-center overflow-hidden">
                  <div className="w-full h-full bg-teal-900 rounded-t-full relative">
                    <div className="absolute w-full h-full bg-amber-300 rounded-full">
                      <img
                        src={data}
                        alt="data"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating cards */}
              <div className="w-full lg:w-auto mt-10 lg:mt-0">
                <div className="flex flex-col gap-6 lg:hidden">
                  {/* Mobile stacked cards */}
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl">
                    <p className="text-sm text-slate-200">
                      To maintain MCT HelpDesk in sync with the external data,
                      data synchronization rules specify how to create, update,
                      and remove each type of object.
                    </p>
                  </div>
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl">
                    <p className="text-sm text-slate-200">
                      External data may be fed into the MCT HelpDesk data
                      synchronization engine via a MySQL connection or a request
                      to a web service after being processed by a third-party
                      ETL (Talend, Pentaho, etc.) or a script.
                    </p>
                  </div>
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl">
                    <p className="text-sm text-slate-200">
                      This functionality allows data in MCT HelpDesk to be
                      automatically and often updated. Control over data
                      synchronization, including mistake detection, is made
                      easier with a synthetic report.
                    </p>
                  </div>
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl">
                    <p className="text-sm text-slate-200">
                      Moreover, a web service allows for the export of all data
                      from MCT HelpDesk in HTML, CSV, and XML formats. MCT
                      HelpDesk offers a query language (OQL) to query the CMDB
                      for sophisticated exports.
                    </p>
                  </div>
                </div>

                {/* Desktop cards – keep your original absolute positions */}
                <div className="hidden lg:block">
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl absolute top-8 left-12 w-[350px]">
                    <p className="text-sm text-slate-200">
                      To maintain MCT HelpDesk in sync with the external data,
                      data synchronization rules specify how to create, update,
                      and remove each type of object.
                    </p>
                  </div>
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl absolute top-10 right-16 w-[300px]">
                    <p className="text-sm text-slate-200">
                      External data may be fed into the MCT HelpDesk data
                      synchronization engine via a MySQL connection or a request
                      to a web service after being processed by a third-party
                      ETL (Talend, Pentaho, etc.) or a script.
                    </p>
                  </div>
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl absolute bottom-6 left-6 w-[350px]">
                    <p className="text-sm text-slate-200">
                      This functionality allows data in MCT HelpDesk to be
                      automatically and often updated. Control over data
                      synchronization, including mistake detection, is made
                      easier with a synthetic report.
                    </p>
                  </div>
                  <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-xl absolute bottom-0 right-12 w-[400px] z-10">
                    <p className="text-sm text-slate-200">
                      Moreover, a web service allows for the export of all data
                      from MCT HelpDesk in HTML, CSV, and XML formats. MCT
                      HelpDesk offers a query language (OQL) to query the CMDB
                      for sophisticated exports.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Detail Section */}
      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid lg:grid-cols-3 gap-12">
          <div className="bg-slate-800 rounded-xl p-8 shadow-sm border border-slate-700 hover:border-teal-600 transition">
            <h3 className="text-2xl font-bold text-white mb-6">HelpDesk</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Monitors and manages user requests within the HelpDesk system
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Identifies and logs their company name automatically on form
                  submissions
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Stores requests in the internal database for lookups or
                  returns based by nature
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Supports manual creation of requests when the HelpDesk
                  provides a user portal for submitting and tracking requests
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-slate-800 rounded-xl p-8 shadow-sm border border-slate-700 hover:border-teal-600 transition">
            <h3 className="text-2xl font-bold text-white mb-6">
              Incident Management
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Conducts automatic impact analysis to determine the right
                  level of response
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Links to all types of records
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Tracks timelines across Incidents and Configuration Items
                  (CIs), including configuration baselines
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Offers a solution through unified channels
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-slate-800 rounded-xl p-8 shadow-sm border border-slate-700 hover:border-teal-600 transition">
            <h3 className="text-2xl font-bold text-white mb-6">
              Problem Management
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Records recurring incidents for identifying root causes
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Tracks RCA documents and links it to incidents and changes to
                  facilitate problem resolution
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Identifies and tracks known errors within the system
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Documents workarounds to address recurring pain points
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-12 mt-12">
          <div className="bg-slate-800 rounded-xl p-8 shadow-sm border border-slate-700 hover:border-teal-600 transition">
            <h3 className="text-2xl font-bold text-white mb-6">
              Tickets Management
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Allows the helper to work on tickets with appropriate status
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Auto-routes cases
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Automatically calculates priority levels based on urgency and
                  impact criteria
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Creates ticket custom views
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-slate-800 rounded-xl p-8 shadow-sm border border-slate-700 hover:border-teal-600 transition">
            <h3 className="text-2xl font-bold text-white mb-6">CMDB</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Manages contact and role organized within the CMDB
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Includes procedures, management dashboard and best practice
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Automates software and application installation for Windows
                  environments
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Manages software and application lifecycle management
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-slate-800 rounded-xl p-8 shadow-sm border border-slate-700 hover:border-teal-600 transition">
            <h3 className="text-2xl font-bold text-white mb-6">
              Change Managemen
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Implements an approval process with defined roles such as
                  manager, supervisor, etc.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Conducts automatic impact analysis to assess the potential
                  effects of proposed changes.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Establishes links between change requests, incidents, and
                  problems to ensure comprehensive management.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm leading-relaxed">
                  Establishes links between changes and the Configuration Items
                  (CIs) affected by them.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* <section className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white py-24 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
              Pricing Plans
            </span>
          </h2>
          <p className="text-slate-400 mb-16 max-w-2xl mx-auto text-lg">
            Transparent and flexible pricing tailored for individuals, startups,
            and enterprises. Upgrade as your business grows.
          </p>

          <div className="grid  md:grid-cols-3">
            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-blue-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Standard</h3>
              <div className="text-5xl font-bold mt-6 text-blue-400">
                05<span className="text-xl text-slate-200">Users</span>
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                  }}
                  className="w-full bg-white text-blue-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 05 Users");
                  }}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-blue-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

            <div className="relative z-10 scale-110 bg-gradient-to-b from-slate-900 to-teal-900 rounded-3xl shadow-2xl p-10  transition duration-300 border border-slate-700">
              <h3 className="text-2xl font-semibold mb-3">Enterprise</h3>
              <div className="text-xl mt-6 font-medium  text-white">
                Contact us for purchase
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => setContactForm(true)}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-blue-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-blue-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Professional</h3>
              <div className="text-5xl font-bold mt-6 text-blue-400">
                10<span className="text-xl text-slate-200">Users</span>
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                  }}
                  className="w-full bg-white text-blue-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 10 Users");
                  }}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-blue-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Helpdesk;
